<h2 mat-dialog-title>Add Job Template</h2>
<mat-dialog-content>
  <form (onSubmit)="save()">
    <app-template-form></app-template-form>
  </form>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button (click)="save()">Save</button>
</div>
